export default {
  "b2b.produkt-detail.title-placeholder": "Produkt",
  "b2b.produkt-detail.message-empty": "Produkt nebyl nalezen"
};
